import { Fragment } from 'react';
import { Link } from 'react-router-dom';

const cards = [
  {
    img: "/images/ar-picking.svg",
    title: "AR Picking",
    description: "Gestisci le missioni di “Picking”, modifica il magazzino e crea utenze per gli operatori",
    buttonName: "INIZIA",
    link: "/upload/arpicking"
  },
  {
    img: "/images/ar-put-light.svg",
    title: "AR Put To Light",
    description: "Gestisci tutte le missioni di “Put To Light”",
    buttonName: "INIZIA",
    link: "/upload/arputtolight"
  },
]

function Selection() {
  return (
    <Fragment>
      <div className="selection_page position-absolute top-0 w-100" style={{ height: "35rem", zIndex: -1 }}></div>

      <div className="container-selection">
        <div className="content-selection">
          <div className="content1">
            <div className='entry-heading' style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
              <h2 style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', gap: '0.5rem' }}>
                <span style={{ display: 'flex', alignItems: 'flex-end', height: '4.5rem' }}>Web</span>
                <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', margin: '0 0.5rem', gap: '0.1rem' }}>
                  <img className="img-l" src="/images/logo-s.png" alt="Cloud" style={{ width: 'clamp(2.5rem, 6vw, 4.5rem)', height: 'auto', marginBottom: '-0.5rem', objectFit: 'contain' }} />
                  <span>Cloud</span>
                </span>
                <span style={{ display: 'flex', alignItems: 'flex-end', height: '4.5rem' }}>Server</span>
              </h2>
            </div>
            <div className="selectionContainer" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', alignItems: 'stretch' }}>
              {cards.map((card, index) => {
                const actionAreaStyle = {
                  alignSelf: 'center',
                  minHeight: '72px', // btn height + padding
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  marginTop: '2rem',
                  marginBottom: '2rem',
                };
                return (
                  <div className="card" key={index} style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, maxWidth: '400px' }}>
                    <div className='border-0 text-center rounded-38' style={{
                      backgroundImage: 'linear-gradient(90deg, #4465af 0%, #8dd5e7 100%)',
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between'
                    }}>
                      <div className="card-thumb" style={{ marginTop: '-38px' }}>
                        <img src={card.img} className="img-fluid" alt="..." />
                      </div>
                      <div className='card-body card-body-selection' style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        <h5 className="">{card.title}</h5>
                        <p className="card-text text-white fw-light">{card.description}</p>
                      </div>
                    </div>
                    <div style={actionAreaStyle}>
                      {index === 1 ? (
                        <span style={{ color: '#fff', fontWeight: 600, fontSize: '1.2rem', borderRadius: '2rem', background: 'rgba(255,255,255,0.10)', padding: '0.75rem 2.5rem', width: 'auto', minWidth: 180, textAlign: 'center' }}>Coming soon</span>
                      ) : (
                        <Link className="btn btn-blue bg-blue fw-bold px-5 py-3 rounded-4 border-2" style={{ minWidth: 180 }} to={card.link}>{card.buttonName}</Link>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
            {/*  <div className="row w-100 justify-content-center" style={{ marginTop: '5rem' }}>
              <div className="col-sm-11">
                <div className="row justify-content-center">
                  {cards.map((card, index) => {
                    return (
                      <div className="card-selection" key={index}>
                        <div className="card border-0 text-center rounded-38" style={{
                          backgroundImage: 'linear-gradient(90deg, #4465af 0%, #8dd5e7 100%)'
                        }}>
                          <div className="card-thumb" style={{ marginTop: '-38px' }}>
                            <img src={card.img} className="img-fluid" alt="..." />
                          </div>
                          <div className='card-body card-body-selection'>
                            <h5 className="">{card.title}</h5>
                            <p className="card-text text-white fw-light fs-19 lh-21">{card.description}</p>
                          </div>
                        </div>
                        <Link className="btn btn-blue bg-blue fw-bold px-5 py-3 rounded-4 border-2 mt-4 mb-5" to={card.link}>{card.buttonName}
                        </Link>
                      </div>
                    )
                  })}

                </div>
              </div>
            </div> */}

          </div>
        </div></div>
      <div className="top_left_circle"></div>
      <div className="right_center_circle"></div>
    </Fragment>
  );
}

export default Selection;
